import { forwardRef, HTMLAttributes, Ref } from 'react'
import styled, { IStyledComponent } from 'styled-components'

import { AddPrefixToObject } from '../../helpers/typeHelper'

interface OdometerReadingTextProps {
  showErrorColor: boolean
  errorColor: string
}

export const StyledOdometerReadingText = styled.span<AddPrefixToObject<OdometerReadingTextProps, '$'>>`
  color: ${(props) => (props.$showErrorColor ? props.$errorColor : 'inherit')};
`

export const OdometerReadingText = forwardRef(
  ({ showErrorColor, errorColor, ...rest }: OdometerReadingTextProps, ref: Ref<any>) => {
    return (
      <StyledOdometerReadingText
        $showErrorColor={showErrorColor}
        $errorColor={errorColor}
        ref={ref}
        {...rest}
      />
    )
  }
) as IStyledComponent<'web', OdometerReadingTextProps & HTMLAttributes<HTMLSpanElement> & { ref?: Ref<any> }>
